module.exports = __webpack_public_path__ + "static/media/familytv.890cadd6.jpg";